import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Mail } from 'lucide-react';

const FooterLight = () => {
  const socialLinks = [
    { icon: Facebook, href: 'https://www.facebook.com/profile.php?id=61574134631498', label: 'Facebook' },
    { icon: Instagram, href: 'https://www.instagram.com/protego.ai/', label: 'Instagram' },
    { icon: Linkedin, href: 'https://www.linkedin.com/company/protego-ai-solutions/', label: 'LinkedIn' },
    { icon: Mail, href: 'mailto:hello@protegoos.com', label: 'Email' },
  ];

  return (
    <footer className="bg-slate-50 border-t border-slate-200 py-12" data-testid="footer">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 items-start">
          {/* Brand & Description */}
          <div>
            <h3 className="font-display text-slate-800 text-xl">Protego AI</h3>
            <div className="mt-3">
              <a 
                href="https://sellercentral.amazon.ca/selling-partner-appstore/dp/amzn1.sp.solution.a216e31d-d6da-475c-80c3-474556a10e53"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity"
              >
                <img 
                  src="/amazon-partner-badge.png" 
                  alt="Amazon Selling Partner Appstore - Software Partner" 
                  className="h-10 w-auto"
                  data-testid="amazon-partner-badge-footer"
                />
              </a>
            </div>
            <p className="text-slate-500 text-sm mt-4 max-w-xs">
              Predictive account health monitoring for Amazon sellers.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-display text-slate-800 text-sm mb-4">Links</h4>
            <nav className="space-y-2">
              <Link to="/privacy" className="block text-sm text-slate-500 hover:text-purple-600 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="block text-sm text-slate-500 hover:text-purple-600 transition-colors">
                Terms of Service
              </Link>
              <a 
                href="https://amazonworkshop.section3.ai/"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-sm text-slate-500 hover:text-purple-600 transition-colors"
              >
                Free Workshop
              </a>
            </nav>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-display text-slate-800 text-sm mb-4">Connect</h4>
            <div className="flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-slate-200 hover:bg-purple-100 hover:text-purple-600 flex items-center justify-center text-slate-500 transition-all"
                  aria-label={social.label}
                >
                  <social.icon className="w-4 h-4" />
                </a>
              ))}
            </div>
            <p className="text-slate-500 text-sm mt-4">
              hello@protegoos.com
            </p>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-slate-200 mt-10 pt-6 text-center">
          <p className="text-xs text-slate-400">
            © {new Date().getFullYear()} Protego AI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterLight;
